import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import devicesState from './state';
const devicesSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => devicesState);
    },
    initialState: devicesState,
    name: 'devices',
    reducers: {
        errorReceiveCarouselDevices: state => {
            state.requestingCarouselDevices = false;
        },
        errorReceiveLockDevices: state => {
            state.requestingLockDevices = false;
        },
        errorReceiveSetCarouselDevice: state => {
            state.requestingSetCarouselDevice = false;
        },
        errorReceiveSetLockDevice: state => {
            state.requestingSetLockDevice = false;
        },
        failedReceiveCarouselDevices: state => {
            state.requestingCarouselDevices = false;
        },
        failedReceiveLockDevices: state => {
            state.requestingLockDevices = false;
        },
        failedReceiveSetCarouselDevice: state => {
            state.requestingSetCarouselDevice = false;
        },
        failedReceiveSetLockDevice: state => {
            state.requestingSetLockDevice = false;
        },
        receiveCarouselDevices: {
            prepare: devices => {
                return {
                    payload: {
                        devices
                    }
                };
            },
            reducer: (state, action) => {
                const { devices } = action.payload;
                state.carouselDevices = devices;
                state.requestingCarouselDevices = false;
            }
        },
        receiveLockDevices: {
            prepare: devices => {
                return {
                    payload: {
                        devices
                    }
                };
            },
            reducer: (state, action) => {
                const { devices } = action.payload;
                state.lockDevices = devices;
                state.requestingLockDevices = false;
            }
        },
        receiveSetCarouselDevice: {
            prepare: device => {
                return {
                    payload: {
                        device
                    }
                };
            },
            reducer: (state, action) => {
                const { device } = action.payload;
                state.carouselDevices = state.carouselDevices.map(carouselDevice => {
                    const { id } = device;
                    return carouselDevice.id === id ? device : carouselDevice;
                });
                state.requestingSetCarouselDevice = false;
            }
        },
        receiveSetLockDevice: {
            prepare: device => {
                return {
                    payload: {
                        device
                    }
                };
            },
            reducer: (state, action) => {
                const { device } = action.payload;
                state.lockDevices = state.lockDevices.map(lockDevice => {
                    const { id } = device;
                    return lockDevice.id === id ? device : lockDevice;
                });
                state.requestingSetLockDevice = false;
            }
        },
        requestCarouselDevices: {
            prepare: (locationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingCarouselDevices = true;
            }
        },
        requestLockDevices: {
            prepare: (locationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingLockDevices = true;
            }
        },
        requestSetCarouselDevice: {
            prepare: (locationSlug, deviceId, setting, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        deviceId,
                        locationSlug,
                        setting
                    }
                };
            },
            reducer: state => {
                state.requestingSetCarouselDevice = true;
            }
        },
        requestSetLockDevice: {
            prepare: (locationSlug, deviceId, setting, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        deviceId,
                        locationSlug,
                        setting
                    }
                };
            },
            reducer: state => {
                state.requestingSetLockDevice = true;
            }
        },
        resetDevices: () => devicesState
    }
});
export const { errorReceiveCarouselDevices, errorReceiveLockDevices, errorReceiveSetCarouselDevice, errorReceiveSetLockDevice, failedReceiveCarouselDevices, failedReceiveLockDevices, failedReceiveSetCarouselDevice, failedReceiveSetLockDevice, receiveCarouselDevices, receiveLockDevices, receiveSetCarouselDevice, receiveSetLockDevice, requestCarouselDevices, requestLockDevices, requestSetCarouselDevice, requestSetLockDevice, resetDevices } = devicesSlice.actions;
export default devicesSlice.reducer;
